// shareOverrides.js
//
// AJUSTES DE FÁBRICA das artes compartilháveis — o que TODO usuário recebe.
//
// Este arquivo é o destino final do trabalho feito no ESTÚDIO (shareStudio.js):
// a pessoa abre a tela de compartilhar, liga o estúdio, arruma a arte com o
// dedo e exporta o JSON. O JSON colado aqui vira o padrão do app.
//
// ── Como atualizar ───────────────────────────────────────────────────────────
// 1. Na tela "Compartilhar", segure 1,2s o título (ou a barra de opções) para
//    destravar o estúdio.
// 2. Arrume as artes. Tudo o que você faz vale para a IMAGEM GERADA: o PNG é
//    capturado do mesmo nó que está na tela, com os mesmos estilos aplicados.
// 3. Toque em "JSON" → "Copiar" e cole o conteúdo dentro de AJUSTES_PADRAO.
// 4. Quem já tinha ajustes salvos no aparelho continua com os DELE até tocar em
//    "Padrão do código" — o localStorage vence o arquivo de propósito, senão o
//    trabalho em andamento sumiria a cada deploy.
//
// ── Formato ──────────────────────────────────────────────────────────────────
//   { "<id da arte>": { "<caminho do elemento>": <patch> } }
//
//   id da arte      '1a'…'1i' (refeição) e '1k'…'1s' (treino) — os mesmos ids
//                   de MEAL_CARD_ORDER / WORKOUT_CARD_ORDER.
//   caminho         'card' para o cartão inteiro; qualquer outro é a trilha
//                   estrutural do elemento (ex.: 'div:2/stat-proteina:0').
//                   Quem escreve esses caminhos é o estúdio — não invente à mão.
//   patch           { dx, dy, escala, giro, fonte, largura, cor, opacidade,
//                     esconder, vars }
//                   dx/dy/largura/fonte em px do CARTÃO (270×480). O PNG sai 4×,
//                   então 1px aqui = 4px no arquivo de 1080×1920.
//
// Exemplo (não é ajuste real, só o desenho do objeto):
//   '1k': { 'card': { vars: { '--story-safe-bottom': '72px' } },
//           'div:2/logo:1': { dy: -4, fonte: 12 } },

// Interruptor MESTRE. `false` ignora tanto os ajustes daqui quanto os do
// aparelho — a arte volta ao layout puro do CSS. Serve de botão de pânico se
// um ajuste ruim chegar em produção.
export const AJUSTES_LIGADOS = true;

// ── Passe do estúdio, 05/09/2026 — 17 artes ─────────────────────────────────
// Refeição (1a…1i) e treino (1k…1s). Ajustado arte por arte conferindo o PNG
// BAIXADO, não a amostra: é o arquivo que o html2canvas desenha e é nele que
// os números batem. Os dy negativos em quase todo <strong> compensam o mesmo
// desvio: o html2canvas assenta o texto um pouco mais baixo que o navegador.
export const AJUSTES_PADRAO = Object.freeze({
  "1a": {
    "bloco-inferior:1/linha-pilulas:0": {
      "dy": 15
    },
    "bloco-inferior:1/linha-pilulas:0/stat-carboidratos:1/span:1": {
      "dy": -3
    },
    "bloco-inferior:1/linha-pilulas:0/stat-carboidratos:1/strong:0": {
      "dy": -8
    },
    "bloco-inferior:1/linha-pilulas:0/stat-gorduras:2/span:1": {
      "dy": -3
    },
    "bloco-inferior:1/linha-pilulas:0/stat-gorduras:2/strong:0": {
      "dy": -8
    },
    "bloco-inferior:1/linha-pilulas:0/stat-proteina:0/span:1": {
      "dy": -3
    },
    "bloco-inferior:1/linha-pilulas:0/stat-proteina:0/strong:0": {
      "dy": -8
    },
    "bloco-inferior:1/rodape-info:1/div:0/span:0": {
      "dy": 8
    },
    "bloco-inferior:1/rodape-info:1/logo:1": {
      "dy": -4
    }
  },
  "1b": {
    "bloco-esquerda:1/logo:4": {
      "fonte": 16
    },
    "bloco-esquerda:1/stat-calorias:3/span:1": {
      "dy": 5,
      "esconder": true
    },
    "bloco-esquerda:1/stat-calorias:3/strong:0": {
      "fonte": 26
    },
    "bloco-esquerda:1/stat-carbo:1/span:1": {
      "dy": 5,
      "fonte": 9
    },
    "bloco-esquerda:1/stat-gorduras:2/span:1": {
      "dy": 5,
      "fonte": 9
    },
    "bloco-esquerda:1/stat-proteina:0/span:1": {
      "dy": 5,
      "fonte": 9
    }
  },
  "1c": {
    "barra-vidro:1": {
      "dx": -7,
      "escala": 0.89,
      "largura": 252
    },
    "barra-vidro:1/stat-carbo:4/span:1": {
      "dy": -2
    },
    "barra-vidro:1/stat-carbo:4/strong:0": {
      "dy": -10
    },
    "barra-vidro:1/stat-gord:6": {
      "dy": -2
    },
    "barra-vidro:1/stat-gord:6/strong:0": {
      "dy": -9
    },
    "barra-vidro:1/stat-kcal:0/span:1": {
      "dy": -2
    },
    "barra-vidro:1/stat-kcal:0/strong:0": {
      "dy": -9
    },
    "barra-vidro:1/stat-prot:2/span:1": {
      "dy": -2
    },
    "barra-vidro:1/stat-prot:2/strong:0": {
      "dy": -9
    },
    "logo:0": {
      "dx": -95,
      "dy": 348
    }
  },
  "1d": {
    "cartao-branco:0/cabecalho-branco:0/logo:1": {
      "dy": -7
    },
    "cartao-branco:0/cabecalho-branco:0/span:0": {
      "dy": -5
    },
    "cartao-branco:0/regua-branca:2": {
      "dy": 4
    },
    "cartao-branco:0/stats-brancos:3/stat-carboidratos:1/span:1": {
      "fonte": 8
    },
    "cartao-branco:0/stats-brancos:3/stat-carboidratos:1/strong:0": {
      "dy": -6
    },
    "cartao-branco:0/stats-brancos:3/stat-gorduras:2/span:1": {
      "fonte": 8
    },
    "cartao-branco:0/stats-brancos:3/stat-gorduras:2/strong:0": {
      "dy": -6
    },
    "cartao-branco:0/stats-brancos:3/stat-proteina:0/span:1": {
      "fonte": 8
    },
    "cartao-branco:0/stats-brancos:3/stat-proteina:0/strong:0": {
      "dy": -6
    },
    "cartao-branco:0/titulo-branco:1": {
      "dy": -5
    }
  },
  "1e": {
    "bloco-anel:2/anel:0/valor-anel:1/strong:0": {
      "dy": -5.5
    },
    "bloco-anel:2/chips:1": {
      "dy": -6
    },
    "bloco-anel:2/chips:1/span:0": {
      "textoY": -6
    },
    "bloco-anel:2/chips:1/span:1": {
      "textoY": -6
    },
    "bloco-anel:2/chips:1/span:2": {
      "textoY": -6
    },
    "logo:1": {
      "dy": 350
    }
  },
  "1f": {
    "bloco-minimo:1/div:0/b:1": {
      "dy": 7
    },
    "bloco-minimo:1/div:0/span:2": {
      "dy": 2,
      "fonte": 12
    },
    "bloco-minimo:1/div:0/strong:0": {
      "dy": -5
    }
  },
  "1h": {
    "faixa-topo:1/div:0/logo:0": {
      "dy": 1
    }
  },
  "1i": {
    "logo:0": {
      "dx": 187,
      "dy": 55
    },
    "trilho-lateral:1": {
      "largura": 56
    },
    "trilho-lateral:1/separador:1": {
      "dy": -2
    },
    "trilho-lateral:1/stat-carbo:3/span:1": {
      "dy": -2
    },
    "trilho-lateral:1/stat-carbo:3/strong:0": {
      "dy": -5
    },
    "trilho-lateral:1/stat-gord:4/span:1": {
      "dy": -2
    },
    "trilho-lateral:1/stat-gord:4/strong:0": {
      "dy": -5
    },
    "trilho-lateral:1/stat-kcal:0/span:1": {
      "dy": -3
    },
    "trilho-lateral:1/stat-kcal:0/strong:0": {
      "dy": -8.5,
      "fonte": 20
    },
    "trilho-lateral:1/stat-prot:2/span:1": {
      "dy": -2
    },
    "trilho-lateral:1/stat-prot:2/strong:0": {
      "dy": -5
    }
  },
  "1k": {
    "bloco-inferior:1/linha-pilulas:1/stat-calories:0": {
      "dy": 35,
      "altura": 40
    },
    "bloco-inferior:1/linha-pilulas:1/stat-calories:0/span:1": {
      "dy": -7
    },
    "bloco-inferior:1/linha-pilulas:1/stat-calories:0/strong:0": {
      "dy": -8
    },
    "bloco-inferior:1/rodape-info:2/div:0/span:0": {
      "dy": 24,
      "fonte": 7
    },
    "bloco-inferior:1/rodape-info:2/div:0/strong:1": {
      "dy": 6,
      "fonte": 28
    },
    "bloco-inferior:1/rodape-info:2/logo:1": {
      "dy": 3
    },
    "bloco-inferior:1/titulo:0": {
      "dy": 102.5,
      "alinhar": "right"
    }
  },
  "1l": {
    "bloco-esquerda:1": {
      "dy": -6
    },
    "bloco-esquerda:1/logo:3": {
      "dy": -10,
      "fonte": 14
    },
    "bloco-esquerda:1/stat-calories:2/span:1": {
      "dy": -6,
      "fonte": 9
    },
    "bloco-esquerda:1/stat-calories:2/strong:0": {
      "dy": -10
    },
    "bloco-esquerda:1/stat-duration:1/span:1": {
      "dy": -2,
      "fonte": 9
    },
    "bloco-esquerda:1/stat-duration:1/strong:0": {
      "dy": -6
    },
    "bloco-esquerda:1/titulo:0": {
      "dy": 1,
      "fonte": 16
    }
  },
  "1m": {
    "barra-vidro:1": {
      "altura": 70
    },
    "barra-vidro:1/stats-vidro:1/stat-calories:2/span:1": {
      "dy": -6
    },
    "barra-vidro:1/stats-vidro:1/stat-calories:2/strong:0": {
      "dy": -9
    },
    "barra-vidro:1/stats-vidro:1/stat-duration:0/span:1": {
      "dy": -6
    },
    "barra-vidro:1/stats-vidro:1/stat-duration:0/strong:0": {
      "dy": -9,
      "largura": 34
    },
    "barra-vidro:1/titulo-vidro:0": {
      "dy": -6
    },
    "logo:0": {
      "dx": -16,
      "dy": 289
    }
  },
  "1n": {
    "cartao-branco:0": {
      "altura": 121
    },
    "cartao-branco:0/cabecalho-branco:0/logo:1": {
      "dy": -11
    },
    "cartao-branco:0/cabecalho-branco:0/span:0": {
      "dy": -8
    },
    "cartao-branco:0/regua-branca:2": {
      "dy": -3
    },
    "cartao-branco:0/stats-brancos:3/stat-calories:1/span:1": {
      "dy": -6
    },
    "cartao-branco:0/stats-brancos:3/stat-calories:1/strong:0": {
      "dy": -12,
      "fonte": 20
    },
    "cartao-branco:0/stats-brancos:3/stat-duration:0/span:1": {
      "dy": -6
    },
    "cartao-branco:0/stats-brancos:3/stat-duration:0/strong:0": {
      "dy": -12,
      "fonte": 20
    },
    "cartao-branco:0/titulo-branco:1": {
      "dy": -13
    }
  },
  "1o": {
    "bloco-ofensiva:2/pilula-ofensiva:0": {
      "dy": 10,
      "largura": 154,
      "altura": 28
    },
    "bloco-ofensiva:2/pilula-ofensiva:0/span:1": {
      "dy": -7,
      "fonte": 12,
      "largura": 117
    },
    "bloco-ofensiva:2/span:1": {
      "fonte": 8
    }
  },
  "1p": {
    "cartao-recorde:2": {
      "altura": 99
    },
    "cartao-recorde:2/b:2": {
      "dy": -24,
      "fonte": 26
    },
    "cartao-recorde:2/div:0/span:1": {
      "dy": -6,
      "fonte": 9
    },
    "cartao-recorde:2/strong:1": {
      "dy": -18.5,
      "fonte": 20
    },
    "logo:1": {
      "dx": -14,
      "dy": 323
    }
  },
  "1q": {
    "bloco-minimo:1/div:0/b:1": {
      "dy": 6
    },
    "bloco-minimo:1/div:0/span:2": {
      "dy": 4
    },
    "bloco-minimo:1/div:0/strong:0": {
      "dy": -5
    }
  },
  "1r": {
    "cartao-lista:0": {
      "altura": 92
    },
    "cartao-lista:0/cabecalho-lista:0/logo:1": {
      "dy": -12
    },
    "cartao-lista:0/cabecalho-lista:0/logo:1/span:0": {
      "dy": -3
    },
    "cartao-lista:0/cabecalho-lista:0/logo:1/span:1": {
      "dy": -3
    },
    "cartao-lista:0/cabecalho-lista:0/strong:0": {
      "dy": -17
    },
    "cartao-lista:0/itens-lista:1/div:0/span:1": {
      "dy": -20
    },
    "cartao-lista:0/itens-lista:1/div:0/svg:0": {
      "dy": -18
    },
    "cartao-lista:0/meta-lista:3": {
      "dy": -30
    },
    "cartao-lista:0/regua-lista:2": {
      "dy": -18
    }
  },
  "1s": {
    "bloco-anel:2/anel:1": {
      "dy": 9
    },
    "bloco-anel:2/anel:1/valor-anel:1": {
      "dy": 4
    },
    "bloco-anel:2/anel:1/valor-anel:1/span:1": {
      "dy": -4
    },
    "bloco-anel:2/anel:1/valor-anel:1/strong:0": {
      "dy": -12,
      "fonte": 26
    },
    "bloco-anel:2/chips:2/span:0": {
      "textoY": -6
    },
    "bloco-anel:2/titulo:0": {
      "dy": 10
    }
  }
});

// ── Ajustes do formato FEED (4:5) ───────────────────────────────────────────
//
// MAPA PRÓPRIO, e não uma cópia escalada do story. Os patches de cima foram
// medidos no cartão 270×480 conferindo o PNG baixado; num cartão 270×337,5 a
// altura útil muda e cada `dy` deixa de valer. Reaproveitá-los colocaria as
// artes de feed torta desde o primeiro dia, com a aparência de estarem
// calibradas.
//
// VAZIO DE PROPÓSITO enquanto nenhuma arte de feed passou pelo estúdio: sem
// patch, a arte sai no layout puro do CSS, que é o ponto de partida honesto.
// O estúdio (toque longo na arte) grava aqui, arte por arte, como fez com as
// 17 do story.
export const AJUSTES_PADRAO_FEED = Object.freeze({});

/**
 * Os ajustes de um formato.
 *
 * @param {string} formato 'STORY' | 'FEED'
 * @returns {object} mapa de patches daquele formato
 */
export function ajustesDoFormato(formato) {
  return formato === 'FEED' ? AJUSTES_PADRAO_FEED : AJUSTES_PADRAO;
}
